import React from "react";
import { LuRefreshCw } from "react-icons/lu";

const RefreshBtn = ({ onClick, text = "", icon = "left", iconSize = 20, spin = false }) => {
  return (
    <button
      onClick={onClick}
      className={`${spin ? "text-fg" : "text-white hover:text-fg cursor-pointer"} transition-all`}
    >
      {icon === "left" && <LuRefreshCw size={iconSize} className={`inline-block mr-2 ${spin ? "animate-spin" : ""}`} />}
      {text}
    </button>
  );
};

export default RefreshBtn;
